import BasePage from "./BasePage";

function BasedLoggedOutPage({children}){
    return <BasePage>{children}</BasePage>;
}

export default BasedLoggedOutPage;